export default __webpack_public_path__ + "static/media/logoSample1.1bfd417c.png";